import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useTranslation } from '@unifyapps/i18n/client';
import { useSnackbar } from '@unifyapps/ui/components/Snackbar';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { BuildControlAction } from './schema/controlBuild';

function useControlBuild() {
  const { t } = useTranslation(['common', 'interfaces-matrix']);
  const { showSnackbar } = useSnackbar();

  const onControlBuild: OnActionType = useEventCallback((args) => {
    const { action } = args;
    const userControlAction = action.payload?.userControlAction;

    switch (userControlAction) {
      case BuildControlAction.DownloadUpdate:
        showSnackbar({
          color: 'warning',
          title: t('interfaces-matrix:pageActions.DownloadUpdate'),
        });
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      case BuildControlAction.RestartApp:
        showSnackbar({
          color: 'warning',
          title: t('interfaces-matrix:pageActions.RestartApp'),
        });
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      case BuildControlAction.OpenDebugMenu:
        showSnackbar({
          color: 'warning',
          title: t('interfaces-matrix:pageActions.OpenDebugMenu'),
        });
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      default:
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    }
  });

  return { onControlBuild };
}

export default useControlBuild;
